<template>
  <div class="wrap">
    <transition :name="transitionName">
      <router-view class="content"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      transitionName: ''
    }
  },
  watch: {// 使用watch 监听$router的变化
    $route (to, from) {
      // 如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    }
  }
}
</script>

<style scoped lang="less">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.wrap{
  height: 100%;
  width: 100%;
  > .content{
    position: absolute;
    top:0rem;
    bottom:0;
    left:0;right:0;
  }
}
& /deep/ .page{
  position: absolute;
  top:5rem;
  bottom:0;
  left:0;right:0;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/topbar.vue